import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

const PENDING_PREFIX = "sr_pending_submit:";

export const savePending = (key, data) =>
  sessionStorage.setItem(PENDING_PREFIX + key, JSON.stringify(data));

export const takePending = (key) => {
  const raw = sessionStorage.getItem(PENDING_PREFIX + key);
  if (!raw) return null;
  sessionStorage.removeItem(PENDING_PREFIX + key);
  try { return JSON.parse(raw); } catch { return null; }
};

export const isSignInRequired = (e) =>
  e?.response?.status === 401 && e?.response?.data?.code === "sign_in_required";

export function useFreeAccess(user) {
  const [status, setStatus] = useState(null);
  const load = useCallback(() => {
    if (!user) { setStatus(null); return; }
    api.get("/free-access/me").then((r) => setStatus(r.data)).catch(() => setStatus(null));
  }, [user]);
  useEffect(() => {
    load();
    window.addEventListener("sr:free-access-changed", load);
    return () => window.removeEventListener("sr:free-access-changed", load);
  }, [load]);
  return { status, reload: load };
}

export function useFreeAccessConfig() {
  const [config, setConfig] = useState(null);
  useEffect(() => {
    api.get("/free-access/config").then((r) => setConfig(r.data)).catch(() => {});
  }, []);
  return config;
}
